<template>  
  <div class="container-fluid">
    <slot v-if="loading == 0">
      <div class="row">
        <div class="col-12 text-center">
          <h4 style="color: #0E1698">Loading the Quote</h4>
        </div>
        <div class="col-12">
          <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
        </div>
      </div>
    </slot>

    <slot v-if="loading == 1">
      <div class="row border-bottom py-2">
        <div class="col-12">
          <button @click="backToList" class="btn btn-link"><i class="fa fa-chevron-left mr-2" aria-hidden="true"></i>Back to Quote List</button>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-xl-3 order-2 order-xl-1">
          <div class="card border-0 mb-0">
            <div class="card-body py-0">
              <div class="row">

                <div class="col-12">
                  <div class="card border-0 mb-0">
                    <div class="card-body pb-0">
                      <div class="row">
                        <div class="col-12">
                          <h5>Quote</h5>
                        </div>
                        <div class="col-12">
                          Quote #: {{ quoteDetails.id }}
                        </div>
                        <div class="col-12">
                          Created On: {{ quoteDetails.created_at | moment("dddd, MMMM Do YYYY") }}
                        </div>
                        <div class="col-12">
                          Created By: {{ quoteDetails.creatorName }}
                        </div>
                        <div class="col-12">
                          Quote Price: {{ quoteDetails.build.build_price | currency }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="card border-0 mb-0">
                    <div class="card-body pb-0">

                      <div class="row">
                        <div class="col-12">
                          <h5>Organization</h5>
                        </div>
                        <div class="col-12">
                          {{ quoteDetails.org.org_title}}
                        </div>
                        <div class="col-12">
                          {{ quoteDetails.org.org_addr_addr1}}
                        </div>
                        <div v-if="quoteDetails.org.org_addr_addr2 != '' && quoteDetails.org.org_addr_addr2 != null" class="col-12">
                          {{ quoteDetails.org.org_addr_addr2}}
                        </div>
                        <div class="col-12">
                          {{ quoteDetails.org.org_addr_city}}
                        </div>
                        <div class="col-12">
                          {{ quoteDetails.org.org_addr_state}}, {{ quoteDetails.org.org_addr_zip}}
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="card border-0 mb-0">
                    <div class="card-body pb-0">

                      <div class="row">
                        <div class="col-12">
                          <h5>Contact</h5>
                        </div>
                        <div class="col-12">
                          {{ quoteDetails.contact.contact_f_name}} {{ quoteDetails.contact.contact_l_name}}
                        </div>
                        <div class="col-12">
                          {{ quoteDetails.contact.contact_p_email}}
                        </div>
                        <div v-if="quoteDetails.contact.contact_p_phone != '' && quoteDetails.contact.contact_p_phone" class="col-12">
                          {{ quoteDetails.contact.contact_p_phone}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <hr class="d-block d-xl-none">
        </div>

        <div class="col-12 col-xl-5 order-3 order-xl-2">
          <div class="card border-0 mb-0">
            <div class="card-body py-0">
              <div class="row">

                <div class="col-12">
                  <div class="card border-0 mb-0">
                    <div class="card-body pb-0">
                      <div class="row">
                        <div class="col-12">
                          <h5>Build</h5>
                        </div>
                        <div class="col-12">
                          Build Name: {{ quoteDetails.build.build_name }}
                        </div>
                        <div class="col-12">
                          Build Price: {{ quoteDetails.build.build_price | currency }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="card border-0 mb-0">
                    <div class="card-body pb-0">
                      <div class="row">
                        <div class="col-12">
                          <h5>Product</h5>
                        </div>
                        <div class="col-12">
                          Product Name: {{ quoteDetails.build.product_name}}
                        </div>
                        <div class="col-12">
                          Product Price: {{ quoteDetails.build.base_price | currency }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="card border-0 mb-0">
                    <div class="card-body pb-0">
                      <div class="row">
                        <div class="col-12">
                          <h5>Optionals</h5>
                        </div>
                        <div class="col-12">
                          {{ quoteDetails.build.build_options.length }} x Optionals
                        </div>
                        <div class="col-12 mb-3">
                          Optionals Price: {{ quoteDetails.build.opt_price | currency }}
                        </div>
                        <div v-if="quoteDetails.build.build_options.length < 1" class="col-12 text-center">
                          No Optionals on this Build
                        </div>
                        <div v-if="quoteDetails.build.build_options.length > 0" class="col-12">
                          <v-client-table :data="quoteDetails.build.build_options" :columns="tableColumns" :options="tableOptions">
                            <div slot="slot1" slot-scope="props">
                              {{ props.row.ext_price | currency }}
                            </div>
                          </v-client-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>

        </div>

        <div class="col-12 col-xl-4 pb-2 order-1 order-xl-3">
          <div class="card border-0 mb-0">
            <div class="card-body py-0">
              <div class="row">
                <div class="col-12">
                  <div class="card border-0 mb-0">

                    <div class="card-body pb-0">
                      <div class="row">
                        <div class="col-12">
                          <!-- <h5>Build</h5> -->
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-12">
                          <button class="btn btn-link  p-0 m-0" @click="viewForm('n')"><h5 class="mb-0 pb-0">View Quote Form</h5></button>
                        </div>
                        <div class="col-12">
                          <small class="">Form will open in new browser window.</small>
                        </div>

                        <transition name="roll" mode="out-in">
                          <div v-if="showViewList == 1" class="col-12 mb-3">
                            <div class="card border my-0 ">
                              <div class="card-body py-1">
                                <div class="row mb-2">
                                  <div class="col-12 small font-weight-bold">More than one form has been created for this quote. Select the one you wish to view.</div>
                                </div>
                                <div class="row mb-2">
                                  <div @click="" v-for="(form,index) in quoteForms" class="col-12">
                                  <a href="#" @click="viewForm(form.id)" class="small">Quote #{{form.quote_id}} dated {{form.dated | moment("dddd, MMMM Do YYYY") }}</a>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-12">
                                    <button @click="showViewList = 0" class="btn btn-sm btn-danger">Close</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </transition>
                      </div>

                      <div class="row mb-3">
                        <div class="col-12">
                          <button class="btn btn-link  p-0 m-0" @click="downloadForm('n')"><h5 class="mb-0 pb-0">Download Quote Form</h5></button>
                        </div>
                        <div class="col-12">
                          <small class="">Form will download to your computer.</small>
                        </div>
                        <transition name="roll" mode="out-in">
                          <div v-if="showDlList == 1" class="col-12 mb-3">
                            <div class="card border mb-1 mt-2">
                              <div class="card-body pt-1 pb-2">
                                <div class="row mb-2">
                                  <div class="col-12 small font-weight-bold">More than one form has been created for this quote. Select the one you wish to view.</div>
                                </div>
                                <div class="row mb-2">
                                  <div @click="" v-for="(form,index) in quoteForms" class="col-12">
                                  <a href="#" @click="downloadForm(form.id)" class="small">Quote #{{form.quote_id}} dated {{form.dated | moment("dddd, MMMM Do YYYY") }}</a>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-12">
                                    <button @click="showDlList = 0" class="btn btn-sm btn-danger">Close</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </transition>
                      </div>

<!--                       <div class="row mb-3">
                        <div class="col-12">
                          <button class="btn btn-link  p-0 m-0" @click="openRegen"><h5 class="mb-0 pb-0">Update Quote Form</h5></button>
                        </div>
                        <div class="col-12">
                          <small class="">Regenerate form with a new offer date and new expiration.</small>
                        </div>

                        <transition name="roll" mode="out-in">
                          <div v-if="showRegenList == 1" class="col-12 mb-3">
                            <div class="card border mb-1 mt-2">
                              <div class="card-body pt-1 pb-2">
                                <div class="row mb-2">
                                  <div class="col-12 small font-weight-bold mb-2">Select a date no more than 6 months from now. A new quote form will be generated with this offer date and a new expiration date.</div>
                                  <div class="col-12 mb-2">
                                    <div class="form-group">
                                      <small class="p-0 mb-0">New Offer Date</small><br>
                                      <date-picker placeholder="Offer Date" :lang="lang" v-model="r_date" input-class="form-control form-control-sm" value-type="format" :format="dateFormat"></date-picker> 
                                      <button v-if="regenButton == false" class="btn btn-sm btn-primary" @click="regenForm" :disabled="regenButton">Go</button>
                                      <div class="d-flex justify-content-start" v-if="regenButton == true" >
                                        <spring-spinner :animation-duration="2000" :size="25" color="#0E1698" class="ml-2"/>
                                        
                                      </div>

                                    </div>
                                  </div>
                                  <div class="col-12"><button class="btn btn-sm btn-danger" @click="closeRegen">Cancel</button></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </transition> 
                      </div>

                      <div class="row">
                        <div class="col-12">
                          <button class="btn btn-link  p-0 m-0" @click="emailForm"><h5 class="mb-0 pb-0">Email Quote Form</h5></button>
                        </div>
                        <div class="col-12">
                          <small class="">Email Quote Form</small>
                        </div>
                        <transition name="roll" mode="out-in">
                          <div v-if="showEmailList == 1" class="col-12 mb-3">
                            <div class="card border mb-1 mt-2">

                              <div v-if="emailSection == 0" class="card-body pt-1 pb-2">
                                <div class="row mb-2">
                                  <div class="col-12 small font-weight-bold">This quote has multiple forms, select the one you wish to email.</div>
                                </div>
                                <div class="row mb-2">
                                  <div @click="" v-for="(form,index) in quoteForms" class="col-12">
                                    <a href="#" @click="selectEmailQuote(form.id)" class="small">Quote #{{form.quote_id}} dated {{form.dated | moment("dddd, MMMM Do YYYY") }}</a>
                                  </div>
                                </div>
                              </div>

                              <div v-if="emailSection == 1" class="card-body pt-1 pb-2">
                                <div class="row mb-2">
                                  <div class="col-12 small font-weight-bold mb-2">Enter up to five email addresses you wish to send this form too.</div>
                                  <div class="col-12 mb-2 text-right small"><a href="#" @click="addAddress">Add Email Address</a></div>
                                  <div v-for="(email,index) in email_quote_addresses" class="input-group col-12 mb-1">
                                    <div class="input-group-prepend">
                                      <button v-if="email_quote_addresses.length > 1" @click="removeAddress(index)" class="btn btn-sm btn-danger" type="button" id="button-addon1"><i class="fa fa-times" aria-hidden="true"></i></button>
                                    </div>
                                    <input type="text" class="form-control  form-control-sm" placeholder="" v-model="email_quote_addresses[index]">
                                  </div>
                                </div>
                              </div>

                              <div v-if="emailSection == 2" class="card-body pt-1 pb-2">
                                <div class="row mb-3 mt-2">
                                  <div class="col-12 d-flex justify-content-between">
                                    <button class="btn btn-sm btn-warning" @click="previewQuote">Preview Email</button>
                                    <button class="btn btn-sm btn-success" @click="emailQuote">Send Email</button>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12 d-flex justify-content-between mb-2">
                                <button class="btn btn-sm btn-danger" @click="closeEmail">Cancel</button>
                                <button v-if="emailSection == 1" class="btn btn-sm btn-primary" @click="nextEmailSec">Next</button>
                              </div>
                            </div>
                          </div>
                        </transition> 
                      </div> -->
                      
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
          <hr class="d-block d-xl-none">
        </div>


      </div>

    </slot>

  </div><!--  end container-fluid div -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'  
import { SpringSpinner } from 'epic-spinners'
import {store} from '../../stores/admin-quote-main-store.js'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';

export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      loading: 0,
      quoteDetails: [],
      quoteForms: [],
      r_date: '',
      dateFormat: 'MM-DD-YYYY',
      lang: 'en',
      tableColumns: ['item_pn', 'item_name', 'qty', 'slot1'],
      tableOptions: {
        skin: 'table table-sm table-hover border-0 vuetable2 custom1',
        filterable: false,
        pagination: { chunk:4 },
        perPageValues: [],
        perPage: 10,
        texts:{
          filter:"",
          count:"",
          filterPlaceholder:"Search",
          page:"Page:",
          noResults:"No matching records",
          loading:'Loading...',
        },
        columnsClasses: {
          item_pn: 'small',
          item_name: 'small',
          qty: 'small text-center',
          slot1: 'small',
        }, 
        headings: { 
          item_pn: 'PN',
          item_name: 'Name',
          qty: 'Qty',
          slot1: 'Price',
        },
      },
      showViewList: 0,
      showDlList: 0,
      showRegenList: 0,
      regenButton: false,
      showEmailList: 0,

      emailSection: 0,
      email_quote_form_id: '',
      email_quote_addresses: [],
      email_quote_message: '',
    }
  },
  computed: {

  },
  watch: {
    
  },
  mounted() {
    this.getBuildInformation();
    this.getFormInformation();
  },
  methods: {
    getMainView(name, x, y, z) { this.$store.dispatch("getMainView", { name: name, prop1: x, prop2: y, prop3: z })  },

    getBuildInformation() {
      var _this = this;
      _this.loading = 0;
      axios.get('/utility/user/quote/getspecificquotedetails/' + _this.prop3[1])
        .then(function (response) {
          var a = response.data.data;
          _this.quoteDetails = response.data.data;
          _this.loading = 1;
        });
    },
    getFormInformation() {
      var _this = this;
      // _this.loading = 0;
      axios.get('/utility/quote/form/getquoteformlist/' + _this.prop3[1])
        .then(function (response) {
          var a = response.data.data;
          _this.quoteForms = response.data.data;
          // _this.loading = 1;
        });
    },
    viewForm(x) {
      var _this = this;
      _this.closeEmail();
      _this.showViewList = 0;
      _this.showRegenList = 0;
      _this.showDlList = 0;
      if(x == 'n') {
        if(_this.quoteForms.length == 0) {
          alert('there is none')
        } else if(_this.quoteForms.length == 1) {
          var a = _this.quoteForms[0].id
          window.open('/utility/quote/form/streamspecificform/' + a);
        } else if(_this.quoteForms.length > 1) {
          _this.showViewList = 1;
        }
      } else {
        window.open('/utility/quote/form/streamspecificform/' + x);
      }
    },
    downloadForm(x) {
      var _this = this;
      _this.closeEmail();
      _this.showViewList = 0;
      _this.showRegenList = 0;
      _this.showDlList = 0;
      if(x == 'n') {
        if(_this.quoteForms.length == 0) {
          alert('there is none')
        } else if(_this.quoteForms.length == 1) {
          var a = _this.quoteForms[0].id
          location.replace('/utility/quote/form/downloadspecificform/' + a);
        } else if(_this.quoteForms.length > 1) {
          _this.showDlList = 1;
        }
      } else {
        location.replace('/utility/quote/form/downloadspecificform/' + x);
      }
    },
    emailForm(x) {
      var _this = this;
      _this.showEmailList = 1;
      _this.showViewList = 0;
      _this.showRegenList = 0;
      _this.showDlList = 0;
      if(_this.quoteForms.length == 0) {
        alert('there is none')
      } else if(_this.quoteForms.length == 1) {
        _this.email_quote_form_id = _this.quoteForms[0].id;
        _this.email_quote_addresses.push(_this.quoteDetails.contact.contact_p_email);
        _this.emailSection = 1;
      } else if(_this.quoteForms.length > 1) {
        _this.emailSection = 0;
      }
    },
    closeEmail() {
      var _this = this;
      _this.showEmailList = 0;
      _this.email_quote_form_id = '';
      _this.email_quote_addresses = [];
      _this.email_quote_message = '';
    },
    selectEmailQuote(x) {
      var _this = this;
      _this.email_quote_form_id = x;
      _this.email_quote_addresses.push(_this.quoteDetails.contact.contact_p_email);
      _this.emailSection = 1;
    },
    addAddress(){
      var _this = this;
      if(_this.email_quote_addresses.length >= 5) {
        return false;
      }
      _this.email_quote_addresses.push('');
    },
    removeAddress(index) {
      var _this = this;
      if(_this.email_quote_addresses.length < 2) {
        return false;
      }
      _this.email_quote_addresses.splice(index,1);
    },
    nextEmailSec() {
      var _this = this;
      var valErrors = [];
      var mailformat = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      for (var i = 0; i < _this.email_quote_addresses.length; i++) {
          var c = i + 1;
          var b = _this.email_quote_addresses[i];
          if (mailformat.test(b)) {
            
          } else {
            valErrors.push("Email address number "+c+" is not a valid email!") 
          }
      }
      if(valErrors.length > 0) { _this.errorDisplay(valErrors); return false; }
      _this.emailSection = 2;
    },

    previewQuote() {
      var _this = this;
      window.open('/utility/user/quote/previewquoteemail/' + _this.quoteDetails.id +'/'+_this.email_quote_form_id);
      // /utility/user/quote/previewquoteemail/{quote}/{form}
      // axios.post( '/utility/user/quote/previewquoteemail/quote_id', {
      //   quote_id: _this.quoteDetails.id,
      //   form_id: _this.email_quote_form_id,
      //   message: _this.email_quote_message,
      // })
      // .then(function(response){
        
      // })
      // .catch(function(error){
      //   var errors = error.response.data.errors;
      //   _this.errorDisplay(errors);
      // });
    },
    emailQuote() {
      var _this = this;
      axios.post( '/utility/user/quote/sendquoteemail', {
        quote_id: _this.quoteDetails.id,
        form_id: _this.email_quote_form_id,
        addresses: _this.email_quote_addresses,
      })
      .then(function(response){
        
      })
      .catch(function(error){
        var errors = error.response.data.errors;
        _this.errorDisplay(errors);
      });
    },
    openRegen() {
      var _this = this;
      _this.closeEmail();
      _this.showViewList = 0;
      _this.showDlList = 0;
      _this.showRegenList = 1;
    },
    regenForm() {
      var _this = this;
      _this.regenButton = true;
      if(_this.r_date == '' || _this.r_date == null) { return false; } 

      var valErrors = [];
      
      var a = moment(_this.r_date);
      var b = moment();
      var c = a.diff(b, 'days');
      if(c > 180) { valErrors.push("The new offer date must be within 6 months of today.") } 
      if(valErrors.length > 0) { _this.errorDisplay(valErrors); _this.saveButton = false; return false; }
      
      axios.post( '/utility/quote/form/regenerateformdate', {
        quote_id: _this.quoteDetails.id,
        date: _this.r_date,
      })
      .then(function(response){
        var msg = response.data.msg;
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        _this.getFormInformation();
        _this.r_date = '';
        _this.regenButton = false;
        _this.showViewList = 0;
        _this.showDlList = 0;
        _this.showRegenList = 0;
      })
      .catch(function(error){
        _this.showRegenList = 1;
        _this.regenButton = false;
        var errors = error.response.data.errors;
        _this.errorDisplay(errors);
      });

    },
    closeRegen() {
      var _this = this;
      _this.r_date = '';
      _this.showRegenList = 0;
    },
    backToList() {
      var _this = this;
      _this.$emit('onUComplete', ['quote-view']);
    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },   
  },    
  components:{
    ScalingSquaresSpinner,
    SpringSpinner,
  },
  filters: {

  }
}
</script>
